<template lang="html">
  <div class="contact">
    <div class="content-title">
      <div class="media">
        <div class="media-body">
          <h1>
            {{ $t("feature.contact.title") }}
          </h1>
          <breadcrumbs :labels="breadcrumbsLabels"></breadcrumbs>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import Breadcrumbs from "./Breadcrumbs";

export default {
  components: {
    Breadcrumbs
  },
  data() {
    return {
      breadcrumbsLabels: ["ข้อมูลการติดต่อทั้งหมด"]
    };
  },
  computed: {
    projectId() {
      return this.$store.state.projectId;
    },
    projectName() {
      return this.$store.state.projectName;
    }
  },
  watch: {
    $route() {
      this.setBreadcrumbs();
    }
  },
  created() {
    this.$on("update:breadcrumbs", this.setBreadcrumbs());
  },
  methods: {
    setBreadcrumbs() {
      this.breadcrumbsLabels = ["ข้อมูลการติดต่อทั้งหมด"];
      if (this.projectName) {
        this.breadcrumbsLabels.push(this.projectName);
      }
    }
  }
};
</script>

<style scoped>
.contact {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  max-height: 100vh;
  overflow-y: auto;
}

.project-icon {
  width: 40px;
  height: 40px;
  background-color: #9f9f9f;
  border-radius: 7.5px;
}
.contact-header {
  font-size: 14px;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.21;
  letter-spacing: -0.1px;
  font-weight: bold;
  color: #000;
}
.contact-header .old,
.contact-detail .old {
  opacity: 0.5;
}
.contact-detail {
  font-size: 13px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.38;
  letter-spacing: -0.1px;
  text-align: left;
  color: #000000;
}
.contact-icon {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background-color: #eeeeee;
  border: solid 1px #ffffff;
}
.emoji-score {
  position: absolute;
  margin-top: 20px;
  margin-left: 20px;
}
.contact-time {
  font-size: 11px;
  font-weight: 500;
  color: #000000;
  opacity: 0.5;
}
.contact-List,
.contact-topic,
.contact-about {
  background-color: #fff;
  border-right: solid 1px #e0e0e0;
  padding: 0px;
  overflow-y: auto;
  overflow-x: hidden;
}
.search {
  padding: 20px;
}
.search:focus {
  outline: none;
}
.search-input {
  width: 100%;
  height: 27px;
  border-radius: 15px;
  border: solid 1px #e0e0e0;
  font-size: 14px;
  padding: 5px 10px;
}
.search-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: #fff;
  min-width: 70px;
  background: url("/static/icons/down-arrow.svg");
  background-repeat: no-repeat;
  background-size: 10px 10px;
  background-position: right 0px top 8px;

  width: 100%;
  height: 27px;
  border: none;
  font-size: 14px;
  font-weight: bold;
}
</style>
